module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/waveform-56ab72522dc5a5df662a5020c855e395.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/waveform.svg
// module id = aQRh
// module chunks = 24